import { useTranslation } from "react-i18next";
import { ChevronDown, EyeOff, Pin, PinOff } from "lucide-react";
import { Button } from "../../components/ui/button/index.js";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown-menu/index.js";
import type { ContactTableColumnId } from "./contacts-column-view.js";

export function ContactsColumnHeaderMenu({
  columnId,
  pinned,
  onTogglePin,
  onHide,
}: {
  columnId: ContactTableColumnId;
  pinned: boolean;
  onTogglePin: () => void;
  onHide: () => void;
}): React.JSX.Element {
  const { t } = useTranslation();
  const label = t(`contacts.columns.${columnId}`);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="size-6 shrink-0 p-0 text-ink-muted hover:text-foreground"
          aria-label={t("contacts.columnMenu.open", { column: label })}
          data-testid={`contact-column-menu-${columnId}`}
          onClick={(event) => event.stopPropagation()}
          onPointerDown={(event) => event.stopPropagation()}
        >
          <ChevronDown size={12} aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="min-w-40 p-1"
        onCloseAutoFocus={(event) => event.preventDefault()}
      >
        <DropdownMenuItem
          className="py-1.5 text-[0.8125rem]"
          onSelect={() => {
            onTogglePin();
          }}
          data-testid={`contact-column-pin-${columnId}`}
        >
          {pinned ? (
            <PinOff size={14} aria-hidden="true" />
          ) : (
            <Pin size={14} aria-hidden="true" />
          )}
          {pinned ? t("contacts.columnMenu.unpin") : t("contacts.columnMenu.pin")}
        </DropdownMenuItem>
        <DropdownMenuItem
          className="py-1.5 text-[0.8125rem]"
          onSelect={() => {
            onHide();
          }}
          data-testid={`contact-column-hide-${columnId}`}
        >
          <EyeOff size={14} aria-hidden="true" />
          {t("contacts.columnMenu.hide")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
